<template>
	<div>
		<div class="row">
			<b-tabs pills v-model="tabIndex">
				<b-tab v-for="(i,idx) in tabList" :key="idx" :title="i.name">
				</b-tab>
				<template #tabs-end>
					<b-nav-item class="filter" role="presentation" 
						@click.prevent="searchFilterButtonClick" href="#"><i class="fas fa-angle-down icon-down"></i><i class="fas fa-angle-up icon-up"></i></b-nav-item>
				</template>
			</b-tabs>
		</div>
        
		<div class="row" style="padding-bottom:20px;">
			<div class="col-md-12 search form minimize"> 			
				<form class="search fuel formsearch" v-on:change="resumePilihan">
					<div class="button_attach_detach" style="float:right;">
						<b-button @click="floatingSearchForm" class="attach detach" variant="light" href="#"><i class="fas fa-angle-right"></i></b-button>
					</div>

					<div class="row">
                        <div class="row col-md-12">
                            <div class="col-md-6">
                                <h6>Bulan</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;"> 
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;" v-for="(item, index) in this.months" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'month-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangeMonth(item, item.Grup)">
                                        <label class="custom-control-label" :for="'month-checkbox-'+item.Id">{{item.Name}}</label>
                                    </div> 
                                </div>
                            </div>
                            <div class="col-md-6">
                                <ReportParamSelect title="Tahun" name="year" v-model="year" :options="years_select" />
                                <!--
                                <h6>Tahun</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;"> 
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.years_checkbox" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'year-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangeYear(item, item.Grup)">
                                        <label class="custom-control-label" :for="'year-checkbox-'+item.Id">{{item.Name}}</label>
                                    </div> 
                                </div> -->
                            </div>
                        </div>
                        <div class="row mt-4" v-if="tabIndex==0"> 
                            <div class="col-md-12">
                                <h6>Kategori</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="checkbox-1" v-model="penerimaan_visibility.penjualan">
                                        <label class="custom-control-label" for="checkbox-1">Penjualan</label>
                                    </div>   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="checkbox-2" v-model="penerimaan_visibility.bunga_deposito">
                                        <label class="custom-control-label" for="checkbox-2">Bunga Depostio</label>
                                    </div>   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="checkbox-3" v-model="penerimaan_visibility.bunga_notpool">
                                        <label class="custom-control-label" for="checkbox-3">Bunga NOTPOOL</label>
                                    </div>   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="checkbox-4" v-model="penerimaan_visibility.bunga_giro">
                                        <label class="custom-control-label" for="checkbox-4">Bunga Giro</label>
                                    </div>    
                                </div>                                                        
                            </div>

                            <div class="col-md-12 mt-4" v-if="penerimaan_visibility.penjualan">
                                <h6>Penjualan</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.penerimaanLabelList(ytd.penerimaan.penjualan_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'penerimaan-penjualan-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePenerimaanLabel(ytd.penerimaan.penjualan_data, item, penerimaan_label.penjualan)">
                                        <label class="custom-control-label" :for="'penerimaan-penjualan-checkbox-'+item.Id">{{item.NamaPenerimaan}}</label>
                                    </div> 
                                </div>
                            </div>

                            <div class="col-md-12 mt-4" v-if="penerimaan_visibility.bunga_deposito">
                                <h6>Bunga Deposito</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.penerimaanLabelList(ytd.penerimaan.bunga_deposito_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'penerimaan-penjualan-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePenerimaanLabel(ytd.penerimaan.bunga_deposito_data, item, penerimaan_label.bunga_deposito)">
                                        <label class="custom-control-label" :for="'penerimaan-penjualan-checkbox-'+item.Id">{{item.NamaPenerimaan}}</label>
                                    </div> 
                                </div>
                            </div>

                            <div class="col-md-12 mt-4" v-if="penerimaan_visibility.bunga_notpool">
                                <h6>Bunga NOTPOOL</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.penerimaanLabelList(ytd.penerimaan.bunga_notpool_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'penerimaan-penjualan-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePenerimaanLabel(ytd.penerimaan.bunga_notpool_data, item, penerimaan_label.bunga_notpool)">
                                        <label class="custom-control-label" :for="'penerimaan-penjualan-checkbox-'+item.Id">{{item.NamaPenerimaan}}</label>
                                    </div> 
                                </div>
                            </div>

                            <div class="col-md-12 mt-4" v-if="penerimaan_visibility.bunga_giro">
                                <h6>Bunga Giro</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md"  style="flex-grow:0;" v-for="(item, index) in this.penerimaanLabelList(ytd.penerimaan.bunga_giro_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'penerimaan-penjualan-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePenerimaanLabel(ytd.penerimaan.bunga_giro_data, item, penerimaan_label.bunga_giro)">
                                        <label class="custom-control-label" :for="'penerimaan-penjualan-checkbox-'+item.Id">{{item.NamaPenerimaan}}</label>
                                    </div> 
                                </div>
                            </div>

                        </div>

                        <div class="row mt-4" v-if="tabIndex==1"> 
                            <div class="col-md-12">
                                <h6>Kategori</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="penerimaan-persentase-checkbox-1" v-model="penerimaan_persentase_visibility.penjualan">
                                        <label class="custom-control-label" for="penerimaan-persentase-checkbox-1">Penjualan</label>
                                    </div>   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="penerimaan-persentase-checkbox-2" v-model="penerimaan_persentase_visibility.cash">
                                        <label class="custom-control-label" for="penerimaan-persentase-checkbox-2">Cash</label>
                                    </div>   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="penerimaan-persentase-checkbox-3" v-model="penerimaan_persentase_visibility.non_cash">
                                        <label class="custom-control-label" for="penerimaan-persentase-checkbox-3">Non Cash</label>
                                    </div>   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="penerimaan-persentase-checkbox-4" v-model="penerimaan_persentase_visibility.cash_per_day">
                                        <label class="custom-control-label" for="penerimaan-persentase-checkbox-4">Cash Per Day</label>
                                    </div> 
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="penerimaan-persentase-checkbox-5" v-model="penerimaan_persentase_visibility.non_cash_per_day">
                                        <label class="custom-control-label" for="penerimaan-persentase-checkbox-5">Non Cash Per Day</label>
                                    </div>    
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="penerimaan-persentase-checkbox-6" v-model="penerimaan_persentase_visibility.rata_rata_per_day">
                                        <label class="custom-control-label" for="penerimaan-persentase-checkbox-6">Rata-Rata Per Day</label>
                                    </div> 
                                </div>
                            </div>

                            <div class="col-md-12 mt-4" v-if="penerimaan_persentase_visibility.penjualan">
                                <h6>Penjualan</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.penerimaanLabelList(ytd.persentase_penerimaan.penjualan_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'penerimaan-persentase-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePenerimaanLabel(ytd.persentase_penerimaan.penjualan_data, item, persentase_penerimaan_label.penjualan)">
                                        <label class="custom-control-label" :for="'penerimaan-persentase-checkbox-'+item.Id">{{item.NamaPenerimaan}}</label>
                                    </div> 
                                </div>                         
                            </div>

                            <div class="col-md-12 mt-4" v-if="penerimaan_persentase_visibility.cash">
                                <h6>Cash</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.penerimaanLabelList(ytd.persentase_penerimaan.cash_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'penerimaan-persentase-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePenerimaanLabel(ytd.persentase_penerimaan.cash_data, item, persentase_penerimaan_label.cash)">
                                        <label class="custom-control-label" :for="'penerimaan-persentase-checkbox-'+item.Id">{{item.NamaPenerimaan}}</label>
                                    </div> 
                                </div>                         
                            </div>

                            <div class="col-md-12 mt-4" v-if="penerimaan_persentase_visibility.non_cash">
                                <h6>Non Cash</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.penerimaanLabelList(ytd.persentase_penerimaan.non_cash_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'penerimaan-persentase-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePenerimaanLabel(ytd.persentase_penerimaan.non_cash_data, item, persentase_penerimaan_label.non_cash)">
                                        <label class="custom-control-label" :for="'penerimaan-persentase-checkbox-'+item.Id">{{item.NamaPenerimaan}}</label>
                                    </div> 
                                </div>                         
                            </div>

                            <div class="col-md-12 mt-4" v-if="penerimaan_persentase_visibility.cash_per_day">
                                <h6>Cash Per Day</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.penerimaanLabelList(ytd.persentase_penerimaan.cash_per_day_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'penerimaan-persentase-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePenerimaanLabel(ytd.persentase_penerimaan.cash_per_day_data, item, persentase_penerimaan_label.cash_per_day)">
                                        <label class="custom-control-label" :for="'penerimaan-persentase-checkbox-'+item.Id">{{item.NamaPenerimaan}}</label>
                                    </div> 
                                </div>                         
                            </div>

                            <div class="col-md-12 mt-4" v-if="penerimaan_persentase_visibility.non_cash_per_day">
                                <h6>Non Cash Per Day</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.penerimaanLabelList(ytd.persentase_penerimaan.non_cash_per_day_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'penerimaan-persentase-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePenerimaanLabel(ytd.persentase_penerimaan.non_cash_per_day_data, item, persentase_penerimaan_label.non_cash_per_day)">
                                        <label class="custom-control-label" :for="'penerimaan-persentase-checkbox-'+item.Id">{{item.NamaPenerimaan}}</label>
                                    </div> 
                                </div>                         
                            </div>

                            <div class="col-md-12 mt-4" v-if="penerimaan_persentase_visibility.rata_rata_per_day">
                                <h6>Rata-Rata Per Day</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.penerimaanLabelList(ytd.persentase_penerimaan.rata_rata_per_day_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'penerimaan-persentase-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePenerimaanLabel(ytd.persentase_penerimaan.rata_rata_per_day_data, item, persentase_penerimaan_label.rata_rata_per_day)">
                                        <label class="custom-control-label" :for="'penerimaan-persentase-checkbox-'+item.Id">{{item.NamaPenerimaan}}</label>
                                    </div> 
                                </div>                         
                            </div>

                        </div>
					</div>
				</form>
			</div> 
		</div> 

        <div class="row" v-if="tabIndex==0"> 
            <div class="col-md-12" v-if="penerimaan_visibility.penjualan">
                <!--<BarCard title="A. PENJUALAN" :data="ytd.penerimaan.penjualan" :width="500" :height="450" url="/treasury"/> -->
                <BarCard :title="'A. PENJUALAN ' + selected_current_year" :data="this.barchartPenerimaan(this.ytd.penerimaan.penjualan_data, this.penerimaan_label.penjualan)" :width="500" :height="450" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div>
            <div class="col-md-12" v-if="penerimaan_visibility.bunga_deposito">
                <BarCard :title="'B. BUNGA DEPOSITO '  + selected_current_year" :data="this.barchartPenerimaan(this.ytd.penerimaan.bunga_deposito_data, this.penerimaan_label.bunga_deposito)" :width="500" :height="300" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div>
            <div class="col-md-12" v-if="penerimaan_visibility.bunga_notpool">
                <BarCard :title="'C. BUNGA NOTPOOL ' + selected_current_year" :data="this.barchartPenerimaan(this.ytd.penerimaan.bunga_notpool_data, this.penerimaan_label.bunga_notpool)" :width="500" :height="450" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div>
            <div class="col-md-12" v-if="penerimaan_visibility.bunga_giro">
                <BarCard :title="'D. BUNGA GIRO ' + selected_current_year" :data="this.barchartPenerimaan(this.ytd.penerimaan.bunga_giro_data, this.penerimaan_label.bunga_giro)" :width="500" :height="500" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div>
        </div>

        <div class="row" v-if="tabIndex==1">
            <div class="col-md-12" v-if="penerimaan_persentase_visibility.penjualan">
                <BarCard :title="'PENJUALAN ' + selected_current_year" :data="this.barchartPenerimaan(this.ytd.persentase_penerimaan.penjualan_data, this.persentase_penerimaan_label.penjualan)" :width="500" :height="450" url="/treasury"/>
            </div>         

            <div class="col-md-12" v-if="penerimaan_persentase_visibility.penjualan">
                <div class="row">
					<div class="col-md-3" v-for="(item, index) in pieChartPenerimaan(ytd.piechart_persentase_penerimaan.penjualan)" :key="index">

                        <div class="card cardptpr mb-4">
                            <div class="card-header cardptpr p-3 pb-0 pt-0">
                                <H6>PENJUALAN {{ item[0].MonthName.toUpperCase() + ' ' + selected_current_year }}</H6>
                            </div>
                            <div class="card-body p-3 pt-0" style="width:100%;">
                                <PieChart :data="pieChartPenerimaanData(item)"
                                    :url="'/treasury?tab=2&'"/>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div class="col-md-12" v-if="penerimaan_persentase_visibility.cash">
                <BarCard :title="'CASH ' + selected_current_year" :data="this.barchartPenerimaan(this.ytd.persentase_penerimaan.cash_data,this.persentase_penerimaan_label.cash)" :width="500" :height="450" style="width:100%;" url="/treasury"/>
            </div>
            <div class="col-md-12" v-if="penerimaan_persentase_visibility.non_cash">
                <BarCard :title="'NON CASH '  + selected_current_year" :data="this.barchartPenerimaan(this.ytd.persentase_penerimaan.non_cash_data,this.persentase_penerimaan_label.non_cash)" :width="500" :height="300" url="/treasury"/>
            </div>
            <div class="col-md-12" v-if="penerimaan_persentase_visibility.cash_per_day">
                <BarCard :title="'CASH PER DAY ' + selected_current_year" :data="this.barchartPenerimaan(this.ytd.persentase_penerimaan.cash_per_day_data,this.persentase_penerimaan_label.cash_per_day)" :width="500" :height="450" url="/treasury"/>
            </div>
            <div class="col-md-12" v-if="penerimaan_persentase_visibility.non_cash_per_day">
                <BarCard :title="'NON CASH PER DAY ' + selected_current_year" :data="this.barchartPenerimaan(this.ytd.persentase_penerimaan.non_cash_per_day_data,this.persentase_penerimaan_label.non_cash_per_day)" :width="500" :height="500" url="/treasury"/>
            </div>
            <div class="col-md-12" v-if="penerimaan_persentase_visibility.rata_rata_per_day">
                <BarCard :title="'RATA-RATA / DAY ' + selected_current_year" :data="this.barchartPenerimaan(this.ytd.persentase_penerimaan.rata_rata_per_day_data,this.persentase_penerimaan_label.rata_rata_per_day)" :width="500" :height="450" url="/treasury"/>
            </div>

            <div class="col-md-12">
                <div class="row">
					<div class="col-md-4" v-if="penerimaan_persentase_visibility.cash">

                        <div class="card cardptpr mb-4">
                            <div class="card-header cardptpr p-3 pb-0 pt-0">
                                <H6>% CASH {{ selected_current_year }}</H6>
                            </div>
                            <div class="card-body p-3 pt-0" style="width:100%">
                                <PieChart :data="pieChartPenerimaanCashSummary(ytd.piechart_persentase_penerimaan.cash)"
                                    :url="'/treasury?tab=2&'"/>
                            </div>
                        </div>
                        
                    </div>

                    <div class="col-md-4" v-if="penerimaan_persentase_visibility.non_cash">

                        <div class="card cardptpr mb-4">
                            <div class="card-header cardptpr p-3 pb-0 pt-0">
                                <H6>% NON CASH {{ selected_current_year }}</H6>
                            </div>
                            <div class="card-body p-3 pt-0" style="width:100%">
                                <PieChart :data="pieChartPenerimaanCashSummary(ytd.piechart_persentase_penerimaan.non_cash)"
                                    :url="'/treasury?tab=2&'"/>
                            </div>
                        </div>
                        
                    </div>

                </div>
            </div>
        </div>
	</div>
</template>

<script>

//import Cafe from '@/components/page/Cafe.js'


import Treasury from '@/components/page/Treasury.js'
import BarCard from '@/views/pages/BarCard.vue'
import PieChart from '@/components/chart/Pie.js'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Footer from '@/views/Footer.vue'
import { Rainbow, Rainbow3, Config, AxiosWithJar, Penanggalan } from '@/utility.js'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable.vue'
import Loader from '@/components/loader/Loader2.vue'

export default
{
	extends: Treasury,
	components: { 
		BarCard,
		PieChart,
		Loader,
        ReportParamSelect,
	},

	data(){
		return {
			options: {
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				status:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "ACTIVE" }, 
					{ value: "0", name: "INACTIVE" }, 
				],
                years:[],
			},
            monthNames: ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"],
            months: [],
            years_local:[],
			tabList:[
				{name:'Penerimaan'},
                {name:'Persentase Penerimaan'},
			],
            penerimaan_visibility: { 
                penjualan: true, 
                bunga_deposito: true, 
                bunga_notpool: true, 
                bunga_giro: true, 
            },
            penerimaan_persentase_visibility: {
                penjualan: true,
                cash: true,
                non_cash: true,
                cash_per_day: true,
                non_cash_per_day: true,
                rata_rata_per_day: true,
            },
            selected_months: [],
            selected_years: [],
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0,  
			year: this.$route.query.year ? this.$route.query.year : Penanggalan().tahun,
			status: this.$route.query.status ? this.$route.query.status : '',
			showmap:false,

			reportdata:[],

		}
	},
    watch:
	{
        year() { this.loadData(this.year); },
    },
    mounted()
    {
        this.$emit('childrenRoute');
		this.loadData(this.year);
        this.loadYears();
        this.loadMonths();
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},

        resumePilihan(){
        },
        /*
		async resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/cafe/cafelist?'

			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&status='+this.status

			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
				})
				.catch(error => {
					//console.log(error)
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
        */
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

        pieChartData(item)
        {
                var warna=[];
                let value = [];
                let idx = 0;
                for (var row in item) {
                    //add color
                    warna[item[row].NamaPengeluaran] = Rainbow[idx];//'#FFB22E'

                    //add value
                    let main = {
                        transtype: item[row].NamaPengeluaran, 
						amount: item[row].Nilai,
                    };

                    value.push(main);
                    idx++;
                }

				return this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

        pieChartPenerimaanData(item)
        {
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].NamaPenerimaan] = Rainbow[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].NamaPenerimaan, 
                    amount: item[row].Nilai,
                };

                value.push(main);
                idx++;
            }

            return this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

        pieChartPenerimaanCashSummary(data)
        {
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in data) {
                
                for(var row2 in data[row]) {
                    //console.log("row2: " + data[row][row2])
                    if(row2 == 0) {
                        //add color
                        warna[data[row][row2].MonthName] = Rainbow[idx]; //'#FFB22E'

                        //add value
                        let main = {
                            transtype: data[row][row2].MonthName, 
                            amount: data[row][row2].Nilai,
                        };

                        value.push(main);
                    }
                }              
                idx++;

            }

            return this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

        penerimaanLabelList(data) {
            //console.log("data: "+ JSON.stringify(data));
            let result = []; 
            for (let i in data) {  
                if(result.some(itm => itm.NamaPenerimaan === data[i].NamaPenerimaan)){
                    //console.log("Object found.");
                } else{
                    //console.log("Object not found. ");
                    result.push(data[i]);
                } 
            }
            //console.log("penerimaanLabelList: " + result);
            //console.log("penerimaanLabelList called");
            return result;
        },

        handleChangePenerimaanLabel(mainLabelData, data, includeLabels) {
            //console.log("checked: "+ JSON.stringify(data));
            //console.log("checked: " + data.Grup);
            
            if(data.Grup == true) {
                //this.penerimaan_label.penjualan.push(data);
                includeLabels.push(data);
            } else {
                //const index = this.penerimaan_label.penjualan.findIndex(prop => prop.NamaPenerimaan === data.NamaPenerimaan)
                //this.penerimaan_label.penjualan.splice(index,1)

                const index = includeLabels.findIndex(prop => prop.NamaPenerimaan === data.NamaPenerimaan)
                includeLabels.splice(index,1)
            }
            
            //this.barchartPenerimaan(mainLabelData, this.penerimaan_label.penjualan);
            this.barchartPenerimaan(mainLabelData, includeLabels);
        },

        barchartPenerimaan(mainData, includes) {
            //console.log("includes : " + JSON.stringify(includes));
            //console.log("mainData : " + JSON.stringify(mainData));

            //console.log("this.selected_months: " + JSON.stringify(this.selected_months) )
            let barchartData = []; //
            let data = mainData;//this.ytd.penerimaan.penjualan_data;
            for (let i in data) {  
                if(includes.some(itm => itm.NamaPenerimaan === data[i].NamaPenerimaan)) {
                    //console.log("Object found. " + data[i].NamaPenerimaan); 
                    /*
                    for(let z in this.selected_months) {
                        console.log("data[i].Bulan: " + data[i].Bulan + "-" + + this.selected_months[z].Id)
                        //console.log("this.selected_months[z]: " + this.selected_months[z].Id)
                        if(parseInt(data[i].Bulan, 0) === parseInt(this.selected_months[z].Id, 0)) {
                            console.log("found data[i].Bulan: " + data[i].Bulan)
                            barchartData.push(data[i]); 
                        }
                             
                    } */
                    
                    if(this.selected_months.some(itm2 => parseInt(itm2.Id, 0) === parseInt(data[i].Bulan, 0)) && this.selected_years.some(itm2 => parseInt(itm2.Id, 0) === parseInt(data[i].Tahun, 0))) {
                        //console.log("month found "+ data[i].Bulan);
                        barchartData.push(data[i]); 
                    } else {
                        //console.log("month not found " + data[i].Bulan);
                    }
                    //barchartData.push(data[i]);             
                   
                } else{
                    //console.log("Object not found. "+ data[i].NamaPenerimaan);
                    
                } 
            }
            return this.processBarChart(barchartData, "NamaPenerimaan", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true);
        },

        loadMonths() {
            for (var i = 0; i <= 11; i++) {
                //console.log("month: " + i);
                let month = { Id: i+1, Name: this.monthNames[i],Grup: 1}
                this.months.push(month);
                this.selected_months.push(month);
            } 
        },
        loadYears() {
            for (var i = 2015; i <= new Date().getFullYear(); i++) {
                let year = {Id: i, Name: i,Grup: 1}
                this.years_local.push(year);
                this.selected_years.push(year);
            }   
        },

        handleChangeMonth(month, isChecked) {
            //console.log("month: " + month.Name +"-"+isChecked);
            if(isChecked == true) {
                this.selected_months.push(month);
            } else {
                const index = this.selected_months.findIndex(prop => prop.Id === month.Id)
                this.selected_months.splice(index,1)
            }
        },

        handleChangeYear(year, isChecked) {
            //console.log("year: " + year.Name +"-"+isChecked);
            if(isChecked == true) {
                this.selected_years.push(year);
            } else {
                const index = this.selected_years.findIndex(prop => prop.Id === year.Id)
                this.selected_years.splice(index,1)
            }
        },

        pieChartPenerimaan(data) {
            let pie = [];
            for(let item in data) {
                if(this.selected_months.some(itm2 => parseInt(itm2.Id, 0) === parseInt(data[item][0].Bulan, 0))) {
                    pie.push(data[item]);
                }
            }
            return pie;
        },

    },
    computed: {
        
    },
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.checkbox-style {
    margin-top: -10px;
}

.checkbox-md .custom-control-label::before, 
.checkbox-md .custom-control-label::after {
  top: .4rem;
  width: 1.2rem;
  height: 1.2rem;
}

.checkbox-md .custom-control-label {
  padding-top: 8px;
  padding-left: 4px;
}

.checkbox-lg .custom-control-label::before, 
.checkbox-lg .custom-control-label::after {
  top: .8rem;
  width: 1.55rem;
  height: 1.55rem;
}

.checkbox-lg .custom-control-label {
  padding-top: 13px;
  padding-left: 6px;
}


.checkbox-xl .custom-control-label::before, 
.checkbox-xl .custom-control-label::after {
  top: 1.2rem;
  width: 1.85rem;
  height: 1.85rem;
}

.checkbox-xl .custom-control-label {
  padding-top: 23px;
  padding-left: 10px;
}

.col-pg {
    flex: 1 0 25%;
}

</style>